// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__324_U","col":"styles_col__1IsqM"};